export default __webpack_public_path__ + "static/media/WISSP_Full_Large.6d439cfb.png";